/**
 *
 * NotesLanding
 *
 */

import { mapMutations } from 'vuex';

export const SelectNoteMixin = {
  name: 'SelectNoteMixin',

  props: {
    p_note: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    ...mapMutations('Notes/NoteDetail', {
      mm_SET_NOTE_IDX: 'SET_NOTE_IDX',
    }),

    selectNote() {
      this.mm_SET_NOTE_IDX(this.p_note.noteIdx);
    },
  },
};
